module.exports = __webpack_public_path__ + "img/itDeclaration.40de19a3.svg";